import {Mask, Popup, Swiper, Tabs, Toast} from "antd-mobile";
import styles from './style.module.scss'
import close from "@/assets/img/landfi/landgold/icon_del@2x.png";
import React, {useEffect, useRef, useState} from "react";
import {GreenBtn} from "@/view/landGame/components/button";
import xuanzhong from "@/assets/img/landfi/xuanzhong.png";
import weixuanzhong from "@/assets/img/landfi/wei-xuan-zhong.png";
import ListView from "@/components/AntListView";
import { recCollList, recInit, recLand} from "@/api/guland";
import {hideLoading, showLoading} from "@/components/loading";

/** recInit.target：0藏品 1管理券 2加速卡 */
const REC_TARGET_NAME = {
  0: '藏品',
  1: '土地管理券',
  2: '加速卡',
};
const REC_TITLE = {
  0: '回收藏品',
  1: '回收土地管理券',
  2: '回收加速卡',
};
const REC_ACTIVITY_CACHE_KEY = 'guland_rec_activity';

const cacheRecActivity = (data = {}) => {
  const payload = {
    id: data.id,
    target: Number(data.target) || 0,
    title: data.title || '',
  };
  try {
    window.localStorage.setItem(REC_ACTIVITY_CACHE_KEY, JSON.stringify(payload));
  } catch (e) {
    console.log(e);
  }
  return payload;
};

const getRecTypeName = (target) => REC_TARGET_NAME[Number(target)] || REC_TARGET_NAME[0];
const getRecTitle = (info = {}) => REC_TITLE[Number(info.target)] || REC_TITLE[0];
const isProductRecycle = (target) => Number(target) === 1 || Number(target) === 2;
/** 列表项上的 limited/remainder：该种加速卡或管理券的活动总限量/剩余 */
const hasItemRemainder = (item = {}) => (
  item.remainder !== null && item.remainder !== undefined && item.remainder !== ''
);
const getItemRemainder = (item = {}) => Math.max(0, Number(item.remainder) || 0);
const getItemLimited = (item = {}) => {
  const limited = Number(item.limited);
  if (Number.isFinite(limited) && limited > 0) return limited;
  return getItemRemainder(item);
};
/** 单品上限 = min(持有数, 该种商品活动剩余 remainder) */
const getProductMaxCount = (item = {}) => {
  const hold = Math.max(0, Number(item.count) || 0);
  if (!hasItemRemainder(item)) return hold;
  return Math.min(hold, getItemRemainder(item));
};
const getExceedLimitToast = (item = {}) => (
  `本次活动限量回收${getItemLimited(item)}个，当前剩余${getItemRemainder(item)}个，已超出回收数量`
);
const getRecItemKey = (item = {}, recTarget) => (
  isProductRecycle(recTarget)
    ? String(item.productId ?? item.id ?? '')
    : String(item.nftNo ?? '')
);
const normalizeRecList = (list = [], recTarget) => {
  if (!isProductRecycle(recTarget)) return list;
  return list.map((item) => ({
    ...item,
    productId: item.productId,
    productName: item.productName || '',
    productImage: item.productImage || '',
    count: Number(item.count) || 0,
    limited: Number(item.limited) || 0,
    remainder: hasItemRemainder(item) ? Number(item.remainder) || 0 : item.remainder,
  }));
};
const dedupeRecList = (list = [], recTarget) => {
  const map = new Map();
  list.forEach((item) => {
    const key = getRecItemKey(item, recTarget);
    if (!key) return;
    map.set(key, item);
  });
  return Array.from(map.values());
};

function generateTabsList(data = {}) {
  const tabsList = [];
  if (!data?.numList || typeof data.numList !== 'object') return tabsList;

  // 判断是“积分”还是“宝石”
  const titleSuffix = data.type === 0 ? '积分' : '宝石';

  // 遍历 numList 对象，生成每个 tab
  Object.keys(data.numList).forEach((key, index) => {
    const tab = {
      key: String(index),  // 索引从 0 开始，作为 key
      title: `${key}${titleSuffix}`  // 生成 title：如 '22宝石' 或 '55积分'
    };
    tabsList.push(tab);
  });

  return tabsList;
}

const RecycleCollectionsModal = ({visible, onClose, callback}) => {
  const [currentTab, setCurrentTab] = useState('0')
  const [selectedCollections, setSelectedCollections] = useState([])
  const [selectedItems, setSelectedItems] = useState([])
  const [selectedQtyMap, setSelectedQtyMap] = useState({})
  const [confirmVisible, setConfirmVisible] = useState(false)
  const swiperRef = useRef(null)
  const mountedRef = useRef(true)
  const [initInfo, setInitInfo] = useState({})
  const [tabList, setTabList] = useState([])
  const [collectionIdsArray, setCollectionIdsArray] = useState([])
  const [backNum, setBackNum] = useState(0)
  const [inited, setInited] = useState(false)

  const recTarget = Number(initInfo?.target) || 0
  const recStarted = Number(initInfo?.state) === 1
  const confirmDisabled = !recStarted || !(selectedCollections?.length > 0)
  const productMode = isProductRecycle(recTarget)

  const resetSelect = () => {
    setSelectedCollections([])
    setSelectedItems([])
    setSelectedQtyMap({})
  }

  useEffect(() => {
    mountedRef.current = true
    return () => {
      mountedRef.current = false
    }
  }, [])

  useEffect(() => {
    if (!visible) {
      setConfirmVisible(false)
      resetSelect()
      return
    }
    getRecInfo()
  }, [visible])

  const getRecInfo = async () => {
    try {
      showLoading()
      setInited(false)
      const res = await recInit()
      if (!mountedRef.current) return
      if (res.code !== '000000') throw res.msg || '获取回收活动失败'
      const data = res.data || {}
      cacheRecActivity(data)
      const nextTabs = data?.numList && typeof data.numList === 'object'
        ? generateTabsList(data)
        : []
      const nextIds = nextTabs.length > 0 ? Object.values(data.numList) : []
      // 一次性写入，避免 Popup 动画中途反复增删 Tabs/Swiper 节点
      setInitInfo(data)
      setTabList(nextTabs)
      setCollectionIdsArray(nextIds)
      setCurrentTab('0')
      setInited(true)
      if (!nextTabs.length) {
        Toast.show('暂无回收活动配置')
      }
      hideLoading()
    } catch (e) {
      hideLoading()
      if (!mountedRef.current) return
      setInitInfo({})
      setTabList([])
      setCollectionIdsArray([])
      setInited(true)
      console.log(e)
      Toast.show(e?.message || e || '获取回收活动失败')
    }
  }
  const onTabClick = (i) => {
    resetSelect()
    setCurrentTab(String(i))
    swiperRef.current?.swipeTo?.(Number(i))
  }
  const choiceItem = (ids, items = []) => {
    const uniqueIds = Array.from(new Set((ids || []).map(String).filter(Boolean)))
    const uniqueItems = []
    const itemMap = new Map()
    ;(items || []).forEach((item) => {
      const key = getRecItemKey(item, recTarget)
      if (!key || itemMap.has(key) || !uniqueIds.includes(key)) return
      itemMap.set(key, item)
      uniqueItems.push(item)
    })
    setSelectedCollections(uniqueIds)
    setSelectedItems(uniqueItems)
    setSelectedQtyMap((prev) => {
      const next = {}
      uniqueIds.forEach((id) => {
        const item = itemMap.get(id)
        const max = getProductMaxCount(item)
        if (max <= 0) return
        next[id] = Math.min(prev[id] || 1, max)
      })
      return next
    })
  }

  const toggleItem = (item) => {
    const key = getRecItemKey(item, recTarget)
    if (!key) return
    const selected = (selectedCollections || []).map(String).includes(key)
    if (selected) {
      choiceItem(
        selectedCollections.filter((id) => String(id) !== key),
        selectedItems.filter((x) => getRecItemKey(x, recTarget) !== key)
      )
      return
    }
    if (productMode && getProductMaxCount(item) <= 0) {
      if (hasItemRemainder(item)) Toast.show(getExceedLimitToast(item))
      return
    }
    choiceItem([...selectedCollections, key], [...selectedItems, item])
  }
  const onQtyChange = (id, qty) => {
    const item = selectedItems.find((x) => getRecItemKey(x, recTarget) === String(id))
    const max = getProductMaxCount(item)
    const safeMax = Math.max(0, Number(max) || 0)
    if (Number(qty) > safeMax) {
      Toast.show(
        item && hasItemRemainder(item)
          ? getExceedLimitToast(item)
          : `已超出回收数量，最多可回收${safeMax}个`
      )
      setSelectedQtyMap((prev) => ({ ...prev, [id]: Math.max(1, safeMax) }))
      return
    }
    const nextQty = Math.min(Math.max(1, Number(qty) || 1), Math.max(1, safeMax))
    setSelectedQtyMap((prev) => ({ ...prev, [id]: nextQty }))
  }
  const getRewardUnit = () => Number(Object.keys(initInfo?.numList || {})[currentTab]) || 0
  const getProductTotalQty = () => selectedCollections.reduce((sum, id) => sum + (selectedQtyMap[id] || 1), 0)
  const getProductSummary = () => selectedItems.map((item) => {
    const id = getRecItemKey(item, recTarget)
    const qty = selectedQtyMap[id] || 1
    return `${qty}张${item.productName || id}`
  }).join('，')

  const openConfirm = () => {
    if (!recStarted) return
    if (productMode) {
      for (const item of selectedItems) {
        const id = getRecItemKey(item, recTarget)
        const qty = selectedQtyMap[id] || 1
        const max = getProductMaxCount(item)
        if (hasItemRemainder(item) && qty > max) {
          Toast.show(getExceedLimitToast(item))
          return
        }
      }
    }
    const unit = getRewardUnit()
    const totalQty = productMode ? getProductTotalQty() : selectedCollections.length
    setBackNum(totalQty * unit)
    setConfirmVisible(true)
  }

  /** 确认前刷新各商品 remainder；任一超出则返回该商品最新剩余数量 */
  const checkProductRemainderExceeded = async () => {
    if (!productMode || !selectedCollections.length) return null
    const params = {
      recId: initInfo?.id,
      currentPage: 1,
      pageSize: Math.max(selectedCollections.length, 20),
      productIds: selectedCollections.map((id) => Number(id) || id),
    }
    const res = await recCollList(params)
    if (res.code !== '000000') return null
    const list = normalizeRecList(res?.data?.list || [], recTarget)
    const map = new Map(list.map((item) => [getRecItemKey(item, recTarget), item]))
    // 同步已选项的最新 remainder，便于后续步进器上限正确
    setSelectedItems((prev) => prev.map((item) => {
      const key = getRecItemKey(item, recTarget)
      return map.get(key) || item
    }))
    for (const id of selectedCollections) {
      const latest = map.get(String(id))
      if (!latest || !hasItemRemainder(latest)) continue
      const remain = getItemRemainder(latest)
      const qty = selectedQtyMap[id] || 1
      if (qty > remain) return remain
    }
    return null
  }

  const confirmHandle = async () => {
    if (!recStarted) return
    try {
      showLoading()
      if (productMode) {
        const exceededRemain = await checkProductRemainderExceeded()
        if (exceededRemain != null) {
          hideLoading()
          Toast.show(`超出当前回收数量，当前剩余数量${exceededRemain}个`)
          return
        }
      }
      const params = {
        recId: initInfo?.id,
        nftNo: productMode ? [] : selectedCollections,
      };
      if (productMode) {
        params.productIds = selectedCollections.map((id) => ({
          [id]: selectedQtyMap[id] || 1,
        }));
      }
      const res = await recLand(params);
      hideLoading()
      if (res.code !== "000000") {
        const remain = res.data?.remainder ?? res.data?.remainCount
        if (productMode && remain != null) {
          Toast.show(`超出当前回收数量，当前剩余数量${remain}个`)
          return
        }
        throw res.msg;
      }
      const rewardName = initInfo.type === 0 ? '积分' : '宝石';
      const total = res.data?.total;
      Toast.show({
        content: total != null ? `回收成功，获得${total}${rewardName}` : "回收成功",
        maskClickable: false,
        afterClose: () => {
          setConfirmVisible(false)
          onClose();
          callback?.()
        },
      });
    } catch (error) {
      hideLoading();
      console.log(error);
      if (productMode) {
        try {
          const exceededRemain = await checkProductRemainderExceeded()
          if (exceededRemain != null) {
            Toast.show(`超出当前回收数量，当前剩余数量${exceededRemain}个`)
            return
          }
        } catch (e) {}
      }
      Toast.show(error);
    }
  };

  return (
    <Popup
      visible={visible}
      position='left'
      bodyStyle={{
        display: 'flex',
        alignItems: 'center',
        width: 'fit-content',
        height: '100%',
        background: 'transparent',
        paddingLeft: 0
      }}
    >
      <div style={{ height: '100%', width: '100vw'}}>
        <div className={styles.recycle_popup}>
          <div className={styles.close_popup} onClick={onClose}><img src={close} alt="" /></div>
          <div className={styles.recycle_title}>{getRecTitle(initInfo)}</div>
          <div className={styles.recycle_time_box}>
            <div className={initInfo?.state === 1 ? styles.start_tag : styles.not_start_tag}>{initInfo?.state === 1 ? '已开始' : '未开始'}</div>
            <div className={styles.time_text}>回收开放时间：{initInfo?.startTime}-{initInfo?.endTime}</div>
          </div>
          <div className={styles.tabs_container}>
            {inited && tabList.length > 0 ? (
              <Tabs className={styles.tabs} activeKey={currentTab} onChange={(key) => onTabClick(key)}>
                {tabList.map((item) => (
                  <Tabs.Tab
                    key={item.key}
                    title={<div className={`${styles.tab_title} ${currentTab === item.key ? styles.tab_select: ''}`}>{item.title}</div>}
                  />
                ))}
              </Tabs>
            ) : null}
          </div>
          <div className={styles.tabs_content}>
            {!inited ? (
              <div className={styles.empty_tip}>加载中...</div>
            ) : collectionIdsArray.length > 0 ? (
              <Swiper
                key={`recycle-swiper-${collectionIdsArray.length}-${initInfo?.id || 0}`}
                direction='horizontal'
                indicator={() => null}
                ref={swiperRef}
                allowTouchMove={false}
                defaultIndex={0}
              >
                {collectionIdsArray.map((item, index) => (
                  <Swiper.Item key={`${initInfo?.id || 'rec'}-${index}`} style={{display: 'flex'}}>
                    <LandList
                      focusStatus={+currentTab === index}
                      radioValue={selectedCollections}
                      onToggleItem={toggleItem}
                      recIds={item}
                      recActivityId={initInfo?.id}
                      recTarget={recTarget}
                      selectedQtyMap={selectedQtyMap}
                      onQtyChange={onQtyChange}
                    />
                  </Swiper.Item>
                ))}
              </Swiper>
            ) : (
              <div className={styles.empty_tip}>暂无可回收内容</div>
            )}
          </div>
          <div className={styles.btn_box}>
            <GreenBtn disabled={confirmDisabled} onClick={confirmDisabled ? undefined : openConfirm}>确 认</GreenBtn>
          </div>
        </div>
        <Mask
          className={styles.confirm_mask}
          visible={confirmVisible}
        >
          <div className={styles.confirm_container}>
            <div className={styles.header}>
              {getRecTitle(initInfo)}
            </div>
            <div className={styles.confirm_tip}>
              {productMode ? (
                <>
                  <div>确认将以下{getRecTypeName(recTarget)}回收吗？</div>
                  <div className={styles.confirm_summary}>{getProductSummary()}</div>
                </>
              ) : (
                <>
                  <div>确认将以下{getRecTypeName(recTarget)}{selectedCollections.toString()}回收，并获得 {backNum} {initInfo.type === 0 ? '积分' : '宝石'}？</div>
                  <div>本次回收操作不可逆</div>
                </>
              )}
            </div>
            <div className={styles.btn_box}>
              <div className={styles.cancel_btn} onClick={() => setConfirmVisible(false)}>取消</div>
              <div className={styles.confirm_btn} onClick={confirmHandle}>确认回收</div>
            </div>
          </div>
        </Mask>
      </div>
    </Popup>
  )
}

const QtyStepper = ({ min = 1, max = 1, value = 1, onChange, onExceed }) => {
  const safeMax = Math.max(0, Number(max) || 0)
  const safeValue = Math.min(safeMax, Math.max(min, Number(value) || min))
  const update = (next) => {
    if (next > safeMax) {
      onExceed?.()
      return
    }
    const qty = Math.min(safeMax, Math.max(min, next))
    onChange?.(qty)
  }
  return (
    <div
      className={styles.qty_stepper}
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
      }}
    >
      <div
        className={styles.qty_btn}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          update(safeValue - 1)
        }}
      >-</div>
      <div className={styles.qty_num}>{safeValue}</div>
      <div
        className={styles.qty_btn}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          update(safeValue + 1)
        }}
      >+</div>
    </div>
  )
}

const LandList = ({
  recIds,
  radioValue,
  focusStatus,
  onToggleItem,
  recActivityId,
  recTarget,
  selectedQtyMap = {},
  onQtyChange,
}) => {
  const [initStatus, setInitStatus] = useState(false)
  const [landData, setLandData] = useState([])
  const [hasMore, setHasMore] = useState(false)
  const [isLoad, setIsLoad] = useState(false)
  const currentPage = useRef(1);
  const pageSize = useRef(20);
  const landDataRef = useRef([]);
  const hasMoreRef = useRef(false);
  const requestRef = useRef(null);

  useEffect(() => {
    if (!initStatus && focusStatus && recActivityId) {
      getRecList(true);
      setInitStatus(true);
    }
  }, [initStatus, focusStatus, recActivityId])

  const updateHasMore = (value) => {
    hasMoreRef.current = value;
    setHasMore(value);
  };

  const getRecList = async (isRefresh = true) => {
    // InfiniteScroll 要求 loadMore 的 Promise 必须等真正请求结束；
    // 加载中不能直接 return，否则会立刻再次触发。
    if (requestRef.current) {
      await requestRef.current;
      if (!isRefresh) return;
    }
    if (!isRefresh && !hasMoreRef.current) return;

    const task = (async () => {
      try {
        if (isRefresh) {
          currentPage.current = 1;
          showLoading();
        } else {
          currentPage.current += 1;
        }
        const params = {
          recId: recActivityId,
          currentPage: currentPage.current,
          pageSize: pageSize.current,
        };
        if (Number(recTarget) === 1 || Number(recTarget) === 2) {
          params.productIds = recIds;
        } else {
          params.collectionIds = recIds;
        }
        const res = await recCollList(params);
        if (res.code !== '000000') throw res.msg;

        const list = dedupeRecList(normalizeRecList(res?.data?.list || [], recTarget), recTarget);
        const prevLength = isRefresh ? 0 : landDataRef.current.length;
        const nextList = isRefresh
          ? list
          : dedupeRecList([...landDataRef.current, ...list], recTarget);
        const addedCount = nextList.length - prevLength;
        landDataRef.current = nextList;
        setLandData(nextList);
        if (isRefresh) setIsLoad(true);

        // 不足一页、或去重后没有新增，都停止，防止 InfiniteScroll 死循环打接口
        const totalCount = Number(res.data?.totalCount ?? res.data?.total ?? 0);
        const nextHasMore =
          list.length >= pageSize.current &&
          addedCount > 0 &&
          (totalCount > 0 ? nextList.length < totalCount : true);
        updateHasMore(nextHasMore);
      } catch (error) {
        if (!isRefresh) {
          currentPage.current = Math.max(1, currentPage.current - 1);
        }
        updateHasMore(false);
        console.log(error);
        Toast.show(error);
      } finally {
        hideLoading();
        requestRef.current = null;
      }
    })();

    requestRef.current = task;
    await task;
  };

  const loadMore = async () => {
    if (!hasMoreRef.current) return;
    await getRecList(false);
  };

  const listItem = (item) => {
    const itemKey = getRecItemKey(item, recTarget);
    const isProduct = isProductRecycle(recTarget);
    const imageUrl = isProduct ? (item.productImage || item.nftImageUrl) : item.nftImageUrl;
    const name = isProduct
      ? (item.productName || '')
      : `#${item.nftNo}`;
    const selected = focusStatus && (radioValue || []).map(String).includes(itemKey);
    const hold = Math.max(0, Number(item.count) || 0);
    const maxCount = isProduct ? getProductMaxCount(item) : Math.max(1, hold);
    const disabled = isProduct && maxCount <= 0;
    return <div
      className={`${styles.list_item} ${disabled ? styles.list_item_disabled : ''}`}
      onClick={() => {
        if (!focusStatus || disabled) return
        onToggleItem?.(item)
      }}
    >
      <div className={styles.list_item_inner}>
        {isProduct ? <div className={styles.item_qty}>{hold}</div> : null}
        <div className={styles.land_img_box}>
          <img className={styles.default_land}
               src={imageUrl} alt=""/>
        </div>
        <p>{name}</p>
        {isProduct && selected ? (
          <QtyStepper
            min={1}
            max={maxCount}
            value={selectedQtyMap[itemKey] || 1}
            onChange={(qty) => onQtyChange?.(itemKey, qty)}
            onExceed={() => {
              Toast.show(
                hasItemRemainder(item)
                  ? getExceedLimitToast(item)
                  : `已超出回收数量，最多可回收${maxCount}个`
              )
            }}
          />
        ) : null}
        <img
          className={styles.select_img}
          src={selected ? xuanzhong : weixuanzhong}
          alt=""
        />
        {item.ownFlag === 1 ? <div className={styles.lease_tag}></div>: null}
      </div>
    </div>
  }
  return <div className={styles.land_list}>
    <ListView
      dataSource={landData}
      hasMore={hasMore}
      style={{paddingTop: 5}}
      renderItem={listItem}
      onEndReached={loadMore}
      isLoad={isLoad}
    />
  </div>
}
export default RecycleCollectionsModal